/* import __COLOCATED_TEMPLATE__ from './custom.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './custom.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsNoteDiagnosisTreatmentPlanCustom extends Component {}
